import { render, staticRenderFns } from "./FitbitArrow.vue?vue&type=template&id=a390fb26"
import script from "./FitbitArrow.vue?vue&type=script&lang=js"
export * from "./FitbitArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports